// extracted by mini-css-extract-plugin
export default {"container":"Cookies_container__Is1-4","heading":"Cookies_heading__VnEY7","policy":"Cookies_policy__BZfvP","subHeading":"Cookies_subHeading__5yxxe","content":"Cookies_content__GI8Hv"};